export default __webpack_public_path__ + "media/images/dividers/testimonial-top-dd365c3bdc8b20907b978689555ab487.svg";